<template>
    <div class="info-tip">
        <common-icon v-if="showIcon" name="info" size="large"></common-icon>
        <slot name="content"></slot>

        <div ref="tipContent" :class="infoTipBulbClass">
            <div class="info-tip__content">
                <slot>{{ content }}</slot>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            content: { type: String, default: undefined },
            isExpanded: { type: Boolean, default: false },
            showIcon: { type: Boolean, default: true },
        },

        data() {
            return {
                isContentInViewport: true,
            }
        },

        computed: {
            infoTipBulbClass() {
                return {
                    'info-tip__bulb': true,
                    'info-tip__bulb--right': !this.isContentInViewport,
                    'info-tip__bulb--left': this.isContentInViewport,
                    'info-tip__bulb--expanded': this.isExpanded,
                }
            },
        },

        methods: {
            isInViewport() {
                const elBulb = this.$refs.tipContent
                const elContent = elBulb.firstChild
                const bounding = elContent.getBoundingClientRect()
                this.isContentInViewport =
                    bounding.top >= 0 &&
                    bounding.left >= 0 &&
                    bounding.right <= window.innerWidth &&
                    bounding.bottom <= window.innerHeight
            },
        },

        mounted() {
            this.isInViewport()
            window.addEventListener('resize', this.isInViewport)
        },

        beforeDestroy() {
            window.removeEventListener('resize', this.isInViewport)
        },
    }
</script>
